export default __webpack_public_path__ + "static/media/logo.7cfd36a5.png";